import * as moment from "moment"
import React from "react"
import { Link } from "react-router-dom"
import { Badge } from "reactstrap"

const formateDate = (date, format) => {
  const dateFormat = format ? format : "HH:mm:ss"
  const date1 = moment(date).format(dateFormat)
  return date1.toString()
}

const formateDates = (datess, format) => {
  const dateFormat = format ? format : "YYYY-MM-DD"
  const dates = moment(datess).format(dateFormat)
  return dates
}

const OrderId = cell => {
  return (
    <Link to="#" className="text-body fw-bold">
      {cell.value ? cell.value : ""}
    </Link>
  )
}

const StartDateTime = cell => {
  return cell ? formateDate(cell) : ""
}

const EndDateTime = cell => {
  return cell ? formateDate(cell) : ""
}

const StartDateTimes = cell => {
  return cell ? formateDate(cell.value) : ""
}

const StartDateactivity = cell => {
  return cell ? formateDates(cell.value) : ""
}
const StartMinusactivity = cell => {
  return cell ? moment.utc(cell.value * 1000).format("HH:mm:ss") : ""
}

const EndtTime = cell => {
  return cell ? formateDate(cell) : ""
}

const EndtTimes = cell => {
  return cell ? formateDate(cell.value) : ""
}

const ProjectName = cell => {
  return cell.value ? cell.value : ""
}

const ClientName = cell => {
  return cell.value ? cell.value : ""
}

const PrivateHrs = cell => {
  return cell.value ? cell.value : ""
}

const IdleHrs = cell => {
  console.log(cell, "ide")
  return cell.value ? cell.value : ""
}

const ManualHrs = cell => {
  return cell.value ? cell.value : ""
}

const BrkHrs = cell => {
  return cell.value ? cell.value : ""
}

const TotalHrs = cell => {
  return cell.value ? cell.value : ""
}

const Date = cell => {
  return cell.value ? cell.value : ""
}
const OnEvaluationHrs = cell => {
  return cell.value ? cell.value : ""
}

const Total = cell => {
  return cell.value ? cell.value : ""
}
const ActiveHrs = cell => {
  return cell.value ? cell.value : ""
}

const PaymentStatus = cell => {
  return (
    <Badge
      className={
        "font-size-12 badge-soft-" +
        (cell.value === "Paid"
          ? "success"
          : "danger" && cell.value === "Refund"
          ? "warning"
          : "success")
      }
      pill
    >
      Active
    </Badge>
  )
}

const PaymentMethod = cell => {
  return (
    <span>
      <i
        className={
          cell.value === "Paypal"
            ? "fab fa-cc-paypal me-1"
            : "" || cell.value === "COD"
            ? "fab fas fa-money-bill-alt me-1"
            : "" || cell.value === "Mastercard"
            ? "fab fa-cc-mastercard me-1"
            : "" || cell.value === "Visa"
            ? "fab fa-cc-visa me-1"
            : ""
        }
      />{" "}
      {cell.value}
    </span>
  )
}
export {
  OrderId,
  StartDateTime,
  EndtTime,
  ProjectName,
  ClientName,
  PrivateHrs,
  IdleHrs,
  ManualHrs,
  BrkHrs,
  TotalHrs,
  Date,
  Total,
  PaymentStatus,
  PaymentMethod,
  ActiveHrs,
  OnEvaluationHrs,
  StartDateTimes,
  EndtTimes,
  StartDateactivity,
  StartMinusactivity,
  EndDateTime
}
